// Configuration du portfolio - Modifiez ces données selon vos informations

export const portfolioData = {
  name: "Jean Pierre Beguerisse",
  title: "Développeur Web Fullstack en alternance",
  tagline:
    "Passionné par la création d'applications web modernes et performantes",
  description:
    "Développeur web fullstack en alternance, spécialisé dans les technologies modernes comme React, TypeScript et Node.js. Je crée des expériences utilisateur exceptionnelles avec un code propre et maintenable.",

  projects: [
    {
      id: 1,
      name: "SocialApp — Réseau social moderne",
      description:
        "Application web complète de type Instagram avec authentification sécurisée, gestion de comptes invités, publication, likes, commentaires, profil, et système de follow/unfollow. Déployée avec Docker sur VPS.",
      image:
        "https://res.cloudinary.com/djidfwdat/image/upload/v1754833042/y4xppdttgm0ix8fmri1n.png",
      stack: [
        "React",
        "Redux",
        "Tailwind CSS",
        "Node.js",
        "Express",
        "MongoDB",
        "Docker",
      ],
      liveUrl: "https://social-app.jeanbeguerisse.com",
      isPrivate: true,
      featured: true,
    },
    {
      id: 2,
      name: "CookSync",
      image:
        "https://res.cloudinary.com/djidfwdat/image/upload/v1757785842/dnh8qqdg98owfej9dgtc.png",
      description:
        "Application web de recettes culinaires avec génération IA, filtrage nutritionnel intelligent, et interface moderne responsive. Intègre Airtable, OpenAI GPT, et APIs d'images pour une expérience culinaire complète.",
      stack: [
        "React",
        "TypeScript",
        "Node.js",
        "Express",
        "Airtable",
        "OpenAI",
        "TailwindCSS",
        "Docker",
      ],
      liveUrl: "https://cooksync.jeanbeguerisse.com/",
      isPrivate: true,
      featured: true,
    },
    {
      id: 3,
      name: "Site vitrine BeBiker",
      description:
        "Site vitrine pour une entreprise de réparation de vélos BeBiker.",
      image:
        "https://res.cloudinary.com/djidfwdat/image/upload/v1754945268/ja7latjfcbdnjarsqfoo.png",
      stack: ["HTML", "CSS"],
      githubUrl: "https://github.com/JPBeguerisse/BeBiker",
      liveUrl: "https://jpbeguerisse.github.io/BeBiker",
      isPrivate: false,
      featured: true,
    },
    // {
    //   id: 4,
    //   name: "Blog Platform",
    //   description:
    //     "Plateforme de blog avec système de commentaires, authentification et interface d'administration.",
    //   image:
    //     "https://via.placeholder.com/400x250/3b82f6/ffffff?text=Blog+Platform",
    //   stack: ["Next.js", "Prisma", "PostgreSQL", "NextAuth"],
    //   githubUrl: "https://github.com/jeanbeguerisse/blog-platform",
    //   liveUrl: "https://blog-platform-demo.vercel.app",
    //   isPrivate: false,
    //   featured: false,
    // },
    // {
    //   id: 5,
    //   name: "Portfolio Website",
    //   description:
    //     "Site portfolio personnel avec design moderne, animations fluides et mode sombre.",
    //   image: "https://via.placeholder.com/400x250/3b82f6/ffffff?text=Portfolio",
    //   stack: ["React", "TypeScript", "TailwindCSS", "Framer Motion"],
    //   githubUrl: "https://github.com/jeanbeguerisse/portfolio",
    //   liveUrl: "https://jeanbeguerisse-portfolio.vercel.app",
    //   isPrivate: false,
    //   featured: false,
    // },
    // {
    //   id: 6,
    //   name: "API Service",
    //   description:
    //     "Service API RESTful avec authentification JWT, documentation Swagger et tests automatisés.",
    //   image:
    //     "https://via.placeholder.com/400x250/3b82f6/ffffff?text=API+Service",
    //   stack: ["Node.js", "Express", "JWT", "Jest"],
    //   githubUrl: "https://github.com/jeanbeguerisse/api-service",
    //   isPrivate: true,
    //   featured: false,
    // },
  ],

  contact: {
    email: "jean.beguerisse@email.com",
    linkedin: "https://linkedin.com/in/jeanbeguerisse",
    github: "https://github.com/jeanbeguerisse",
  },
};
